import {
  getStudentExamResult,
  getStudentExamResults,
  getStudentsExtrasApi,
} from '@apis/api/student/common';
import { useQuery } from 'react-query';
import { studentQueryKeys } from './user';

const getStudentExamResultsQueryKey = (
  studentId: number,
  pageNumber: number,
  pageSize: number,
) => ['STUDENT_EXAM_RESULTS', studentId, pageNumber, pageSize] as const;

export const useStudentExamResultsQuery = (
  studentId: number,
  pageNumber: number,
  pageSize: number,
) => {
  return useQuery(
    getStudentExamResultsQueryKey(studentId, pageNumber, pageSize),
    async () => {
      const data = await getStudentExamResults(studentId, {
        page: pageNumber,
        pageSize: pageSize,
      });
      return data;
    },
  );
};

export const getStudentExamResultDetailQueryKey = (examResultId: number) =>
  ['STUDENT_EXAM_RESULT_DETAIL', examResultId] as const;

export const useStudentExamResultDetailQuery = (examResultId: number) =>
  useQuery(
    getStudentExamResultDetailQueryKey(examResultId),
    async () => {
      const data = await getStudentExamResult(examResultId);

      return data.data;
    },
    {
      enabled: Boolean(examResultId),
    },
  );

export const useStudentsExtrasQuery = (studentIds: number[]) =>
  useQuery(
    studentQueryKeys.extraByIds(studentIds),
    async () => {
      const data = await getStudentsExtrasApi({ studentIds });
      return data;
    },
    {
      enabled: studentIds?.length > 0,
    },
  );
